<template>
  <div>
    <ol class="breadcrumb 2">
			<li><router-link to="/home"><i class="entypo-home"></i>Home</router-link></li>
			<li class="active"><strong>Proyecto</strong></li>
		</ol>
		<h2 class="margin-bottom">Proyecto</h2>

		<div class="row">
			<div class="col-md-12">
				<div id="toolbar">
            <router-link to="/projects/edit"><button class="btn btn-success btn-sm"><i class="fa fa-plus"></i> Nuevo</button></router-link>
			      <button class="btn btn-danger btn-sm" @click="deleteRows()" v-if="$root.user.roles[0].id == 1"><i class="fa fa-trash"></i> Borrar</button>
			    </div>
				<table id="rows"></table>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
  export default {
  data(){
    return {
      rows:[],
    }
  },
  methods:{
    mounthTable(){
      jQuery('#rows').bootstrapTable({
        columns: [
          {
            field:"check",
            checkbox:true,
            align: 'center',
          },
          {
            field: 'id',
            title: '#',
            sortable:false,
            switchable:true,
          },        
          {
            field: 'image',
            title: ' ',
            sortable:false,
            width:"52px",
          },  
          {
            field: 'title',
            title: 'Titulo',
            sortable:true,
            switchable:true,
          },
          {
            field: 'created',
            title: 'Fecha de registro',
            sortable:true,
            switchable:true,
          },
          {
            field: 'updated',
            title: 'Fecha de actualización',
            sortable:true,
            switchable:true,
          }

          
        ],
        showRefresh:true,
      });

      jQuery('#rows').on('refresh.bs.table',()=>{
        this.getRows();
      });

      jQuery('#rows').on('click-row.bs.table',(row,data)=>{
        this.$router.push('/projects/edit/'+data.id);
      });

      this.getRows();

    },
    getRows(){
      this.$parent.inPetition=true;
      axios.get(tools.url("/api/admin/projects")).then((response)=>{
          this.rows = response.data;
          jQuery('#rows').bootstrapTable('removeAll');
          jQuery('#rows').bootstrapTable('append',this.rows);
          this.$parent.inPetition=false;
        }).catch((error)=>{
            this.$parent.handleErrors(error);
            this.$parent.inPetition=false;
        });
    },

    deleteRows:function(){
      var rows=jQuery('#rows').bootstrapTable('getSelections');
      if(rows.length==0){
        return false;
      }
      alertify.confirm("Alerta!","¿Seguro que deseas borrar "+rows.length+" registros?",()=>{
        this.$parent.inPetition=true;
        var params={};
        params.ids=jQuery.map(rows,(row)=>{
          return row.id;
        });

        axios.delete(tools.url('/api/admin/projects'),{data:params})
        .then((response)=>{
          this.$parent.showMessage(response.data.msg,"success");
          this.getRows();
          this.$parent.inPetition=false;
        })
        .catch((error)=>{
          this.$parent.handleErrors(error);
              this.$parent.inPetition=false;
        });
      },
      ()=>{
      });
    }
  },
      mounted() {
          this.mounthTable();
      }
  }
</script>
